import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { AutentificacionService } from '../_services/autentificacion.service';
import { NavController } from '@ionic/angular';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subject, takeUntil } from 'rxjs';
import { EntornoService } from '../_services/entorno.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
  standalone: false,
})
export class LoginPage implements OnInit, OnDestroy {
  private authService = inject(AutentificacionService);
  private navCtrl = inject(NavController);
  private responsive = inject(BreakpointObserver);
  entornoService = inject(EntornoService);

  restablecerContrasena: boolean = false;
  accederFactor2FA: boolean = false;
  acceder: boolean = true;
  esResolucionMovil = !this.responsive.isMatched(Breakpoints.WebLandscape);
  destroy$ = new Subject<void>();

  constructor() {}

  ngOnInit() {
    this.comprobarUsuarioLogeado();

    this.responsive
      .observe([Breakpoints.WebLandscape])
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        if (result.matches) {
          this.esResolucionMovil = false;
        } else {
          this.esResolucionMovil = true;
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  comprobarUsuarioLogeado() {
    if (this.authService.isAuthenticated()) {
      this.navCtrl.navigateRoot('/');
    }
  }

  //Funcion asociada al botón de volver atrás --> se muestra en RestablecerContraseña
  volverAtras() {
    if (this.restablecerContrasena) this.restablecerContrasena = false;
  }

  //Funcion que recibe el evento que emite el botón de "restablecer contraseña"
  //y cambia a true --> visualizar el componente de restablecer contraseña.
  onRestablecerContrasena() {
    this.restablecerContrasena = true;
  }

  correoEmitido: string | null = null;
  claveEmitida: string | null = null;
  //Funcion para ver el componente de factor2FA (recibe el correo emitido por acceso)
  onAcceso2FA(datos: { correo: string; clave: string }) {
    this.accederFactor2FA = true;
    this.acceder = false;
    this.correoEmitido = datos.correo;
    this.claveEmitida = datos.clave;
  }


  onVolverAtras() {
    this.acceder = true;
    this.restablecerContrasena = false;
    this.accederFactor2FA = false;
    this.correoEmitido = null;
  }
}
